<template>
    <BreadCrumb PageTitle="Liste des Incoterms" />
    <ListeIncoterm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeIncoterm from "@/components/Incoterm/ListeIncoterm.vue";

export default defineComponent({
    name: "ListeIncotermPage",
    components: {
        BreadCrumb,
        ListeIncoterm,
    },
});
</script>